/* eslint-disable prettier/prettier */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { useMutation } from "@tanstack/react-query";

import instance from "services/axiosServices";
import leadsWebEnviroment from "utils/leadsWebEnviroment";

interface Props {
  idCampanha: string;
  ativo: boolean;
  idsCorretorSistemaOrigem: string[];
}

export function useEditarCampanha() {
  const putData = async (props: Props) => {
    const EDITAR_CAMPANHA = `${leadsWebEnviroment}/common/campanha/v1`;
    const response = await instance.put(EDITAR_CAMPANHA, {
      idCampanha: props.idCampanha,
      ativo: props.ativo,
      idsCorretorSistemaOrigem: props.idsCorretorSistemaOrigem,
    });
    return response?.data?.data;
  };
  const mutation = useMutation({
    mutationFn: putData,
    onSuccess: () => {},
    onError: () => {},
  });

  return mutation;
}
